import React from "react";
import { BadgeCheck } from "lucide-react";
import { getCategory, getStatus } from "@/lib/categories";
import { cn } from "@/lib/utils";

export const VerifiedBadge = ({ className = "", size = 15 }) => (
  <BadgeCheck className={cn("text-cyan-400 fill-cyan-400/15", className)} style={{ width: size, height: size }} aria-label="Verified agent" />
);

export const CategoryBadge = ({ category, className = "" }) => {
  const c = getCategory(category);
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold", c.badge, className)}>
      {category}
    </span>
  );
};

export const StatusPill = ({ status, className = "" }) => {
  const s = getStatus(status);
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider", s.text, className)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {s.label}
    </span>
  );
};

export const CapabilityBadge = ({ label, className = "" }) => (
  <span className={cn("inline-flex items-center rounded-md border border-white/10 bg-white/[0.04] px-2 py-0.5 text-[11px] font-medium text-slate-300", className)}>
    {label}
  </span>
);

export default CategoryBadge;
